var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 10.1C26.6075 10.1 27.1 9.60751 27.1 9C27.1 8.39249 26.6075 7.9 26 7.9L26 10.1ZM1.22218 8.22218C0.792606 8.65176 0.792606 9.34824 1.22218 9.77782L8.22254 16.7782C8.65212 17.2078 9.3486 17.2078 9.77818 16.7782C10.2078 16.3486 10.2078 15.6521 9.77818 15.2225L3.55564 9L9.77817 2.77746C10.2078 2.34788 10.2078 1.6514 9.77817 1.22183C9.3486 0.79225 8.65212 0.79225 8.22254 1.22183L1.22218 8.22218ZM26 7.9L2 7.9L2 10.1L26 10.1L26 7.9Z",
    fill: "#0C5DA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowback);
export default __webpack_public_path__ + "static/media/arrowback.b70b1449b1a102ccd82947100c11b4ba.svg";
export { ForwardRef as ReactComponent };